const CONFIG_STORAGE_KEY = 'siteConfig';

export function guardarSiteConfig(config, options = {}) {
    if (typeof window === 'undefined' || !config) {
        return;
    }

    window.__SITE_CONFIG__ = config;
    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));

    if (options.dispatchEvent !== false) {
        window.dispatchEvent(new CustomEvent('site-config-updated', { detail: config }));
    }
}

export function obtenerSiteConfigGuardada() {
    if (typeof window === 'undefined') {
        return null;
    }

    if (window.__SITE_CONFIG__) {
        return window.__SITE_CONFIG__;
    }

    const configGuardada = localStorage.getItem(CONFIG_STORAGE_KEY);
    if (!configGuardada) {
        return null;
    }

    try {
        const config = JSON.parse(configGuardada);
        window.__SITE_CONFIG__ = config;
        return config;
    } catch (error) {
        console.error('Error al leer la configuración guardada:', error);
        return null;
    }
}

export function obtenerLogoGuardado() {
    return obtenerSiteConfigGuardada()?.logo || null;
}

export function obtenerNombreTiendaGuardado() {
    return obtenerSiteConfigGuardada()?.nombreTienda?.trim() || '';
}

export function obtenerWhatsappVisibleGuardado() {
    const value = obtenerSiteConfigGuardada()?.showWhatsappButton;
    if (value === undefined || value === null || value === '') {
        return true;
    }

    return Boolean(Number(value));
}
